export enum ProductSubtypes {
    ALCOHOLIC = 1 << 0,
}
